module.exports = __webpack_public_path__ + "img/sub5_step8.8ab5f8d1.png";